import * as React from "react";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { CircularProgress } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";

import {
  orangePeelColor,
  atlanticColor,
} from "assets/jss/material-dashboard-pro-react";

import { signInWithGoogle } from "services/firebase";

export default function NewsDialog() {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState({
    portal: false,
    deleteUser: false,
  });

  // React.useEffect(() => {
  //   const hasSeenPopup = localStorage.getItem("hasSeenPremiumPopup");

  //   if (!hasSeenPopup) {
  //       setOpen(true);
  //       localStorage.setItem("hasSeenPremiumPopup", "true");
  //   }
  // }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubscribe = () => {
    if (typeof gtag === "function") {
      gtag("event", "dialog_premium_click", {
        location: "home_page",
      });
    }
    signInWithGoogle();
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="premium-dialog-title"
      aria-describedby="premium-dialog-description"
      slotProps={{
        paper: {
          sx: {
            position: "relative",
            overflow: "visible",
          },
        },
      }}
      sx={{
        "& .MuiPaper-root": {
          backgroundColor: "#fbfaf8",
        },
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(0, 0, 0, 0.25)",
        },
      }}
    >
      <DialogTitle id="premium-dialog-title">
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
          <Box component="span" sx={{ textAlign: "center" }}>
            <h4
              style={{
                fontFamily: "Be Vietnam, sans-serif",
                fontWeight: "300",
                lineHeight: "1.5em",
              }}
            >
              premium is now free!
            </h4>
          </Box>
        </Box>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            width: 32,
            height: 32,
            top: -12,
            left: -12, // moved from right to left
            backgroundColor: orangePeelColor[0],
            color: "white",
            boxShadow: 3,
            "&:hover": {
              backgroundColor: "#e58e14",
            },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <DialogContentText
          id="premium-dialog-description"
          style={{
            fontFamily: "Be Vietnam, sans-serif",
            fontWeight: "400",
            fontSize: "1rem",
          }}
        >
          Enjoy all <a href="/plans">premium features</a> at no extra cost.
        </DialogContentText>
      </DialogContent>

      <DialogActions
        sx={{
          padding: "16px",
        }}
      >
        <div style={{ display: "flex", marginLeft: "auto" }}>
          <Button
            color="primary"
            sx={{
              width: "152px",
              backgroundColor: atlanticColor[0],
              color: "white",
              "&:hover": {
                backgroundColor: "#032A4A",
              },
            }}
            onClick={handleSubscribe}
          >
            {loading.deleteUser ? (
              <CircularProgress color="secondary" size={30} />
            ) : (
              <>Get Premium</>
            )}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
}
